// extracted by mini-css-extract-plugin
export var articleTitle = "article-title-module--articleTitle--57ba8";